var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophoneStudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C14.4841 15.9972 16.4972 13.9841 16.5 11.5V4.5C16.5 2.01472 14.4853 0 12 0C9.51472 0 7.5 2.01472 7.5 4.5V11.5C7.50276 13.9841 9.51586 15.9972 12 16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8C18.4477 8 18 8.44772 18 9V11.5C18 14.8137 15.3137 17.5 12 17.5C8.68629 17.5 6 14.8137 6 11.5V9C6 8.44772 5.55228 8 5 8C4.44772 8 4 8.44772 4 9V11.5C4.00533 15.4484 6.88604 18.8044 10.788 19.408C10.9099 19.4268 11 19.5316 11 19.655V23C11 23.5523 11.4477 24 12 24C12.5523 24 13 23.5523 13 23V19.655C13 19.5316 13.0901 19.4268 13.212 19.408C17.114 18.8044 19.9947 15.4484 20 11.5V9C20 8.44772 19.5523 8 19 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneStudio);
export default __webpack_public_path__ + "static/media/microphoneStudio.8ef9f01b.svg";
export { ForwardRef as ReactComponent };